import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useMatterRequestLanguageSelect } from './useMatterRequestLanguageSelect';

interface MatterRequestLanguageSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the language list is only fetched where the field is rendered. It renders
 * the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestLanguageSelect = ({
  onOpenPicker,
  onClear,
}: Readonly<MatterRequestLanguageSelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestLanguageSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('common:language')}
      placeholder={t('common:selectLanguage')}
      searchPlaceholder={t('common:searchLanguages')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="language"
      data-testid="select-language-button"
    />
  );
};

export default MatterRequestLanguageSelect;
